import { Trans, useTranslation } from 'react-i18next';
import { nsNewsletter } from '@/app/i18n/namespaces';

// Sprint number : 2603
const Sp2603Newsletter060126 = () => {
    const { t: translate } = useTranslation(nsNewsletter);
    const elements = { 1: <b />, 2: <b /> };

    return (
        <div className='space-y-4'>
            <p className='font-semibold text-lg text-primary'>
                {translate('editions.sp2603.title')}
            </p>
            <ul className='list-disc ml-8 space-y-2'>
                <li><Trans t={translate} i18nKey='editions.sp2603.item1' components={elements} /></li>
                <li><Trans t={translate} i18nKey='editions.sp2603.item2' components={elements} /></li>
            </ul>
        </div>
    );
};

export default Sp2603Newsletter060126;
